<template>
  <div class="inner-row" :style="sprps.gstyle">
    <div class="crx-cell xs4">
      <span class="crx-cell-label">
        Batch
      </span>
      <v-layout align-center class="ma-0">
        <img
        :class="{'crx-greyscale': debits[row.inventory_item_id][row.archive_id] === 0}"
        src="@/assets/img/illustrations/cardboard-box.png"
        alt="cardboard box"
        height="45px"
        width="45px">
        <span class="subheading font-weight-medium">
          {{ archiveItem.batch_number || 'Batch not set' }}
        </span>
      </v-layout>
    </div>

    <div class="crx-cell xs4">
      <span class="crx-cell-label">
        Available
      </span>

      <v-chip
      text-color="white"
      :color="chipColor">
        <c-metric-selector
        class="font-weight-medium"
        labelMode
        alwaysScale
        :inventoryItemID="definition.id" 
        :realValue="balance">
        </c-metric-selector>
      </v-chip>
    </div>

    <div class="crx-cell xs4">
      <span class="crx-cell-label">
        Used
      </span>

      <v-layout align-end pa-0 ma-0>
        <v-btn 
        icon 
        small
        @click="subtractRemainder" :disabled="totalDebits === required[row.inventory_item_id]">
          <v-icon color="blue-grey darken-4">arrow_downward</v-icon>
        </v-btn>

        <c-metric-selector
        ref="metricSelector"
        :inventoryItemID="definition.id"
        :realValue.sync="debits[definition.id][row.archive_id]">

          <v-progress-linear
          class="ma-0"
          v-model="quantityProgress"
          height="5"
          slot="progress"
          :color="progressColor"
          ></v-progress-linear>
        
        </c-metric-selector>

        <v-btn 
        icon 
        small
        :disabled="debits[row.inventory_item_id][row.archive_id] === 0"
        @click="debits[row.inventory_item_id][row.archive_id] = 0">
          <v-icon color="blue-grey darken-4">clear</v-icon>
        </v-btn>

      </v-layout>
    </div>

  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js'

export default {
  props: {
    sprps: null,
    row: null,
    mainrow: null,
    debits: { // [{inventory_id: 666}, ...]
      type: Object,
      default: () => {
        return {}
      }
    },
    debitsFrozen: { // [{inventory_item_id, archive_id, quantity}, ...]
      type: Array,
      default: () => {
        return []
      }
    },
    required: { // {inv_item_id: quantity, inv_item_id: quantity}
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      // 5
    }
  },
  computed: {
    archiveItem () {
      return this.$store.state.db.inventoryArchive.archive[this.row.archive_id]
    },
    definition () {
      return this.$store.state.db.inventoryDefinitions.definitions[this.row.inventory_item_id]
    },
    quantityProgress () {
      var ratio = new BigNumber(this.balance).div(this.totalAvailable).multipliedBy(100)
      if (isNaN(ratio)) {
        return 100
      }
      if (ratio < 0) {
        return 0
      }
      return ratio.toNumber()
    },
    progressColor () {
      return 'blue-grey darken-2'
    },
    balance () {
      return new BigNumber(this.totalAvailable).minus(this.debits[this.definition.id][this.row.archive_id] || 0).toFixed(6)
    },
    totalAvailable () {
      return this.row.quantity
    },
    totalDebits () {
      var archiveDict = Object.values(this.debits[this.row.inventory_item_id])
      return Object.values(archiveDict).reduce((a, b) => a + (b || 0), 0)
    },
    chipColor () {
      if (this.balance <= 0) {
        return 'pink'
      }
      return 'green'
    }
  },
  methods: {
    subtractRemainder () {
      var dif = this.required[this.row.inventory_item_id] - this.totalDebits
      var mod = 0
      var currentBatchDebit = this.debits[this.row.inventory_item_id][this.row.archive_id] || 0
      if (currentBatchDebit + dif > this.totalAvailable) {
        mod = this.totalAvailable
      } else {
        mod = currentBatchDebit + dif
      }
      if (mod < 0 || isNaN(mod)) {
        mod = 0
      }
      this.debits[this.row.inventory_item_id][this.row.archive_id] = mod
      this.$nextTick(() => {
        this.$refs.metricSelector.rescale()
      })
    }
  }
}
</script>
